import { createContext, useContext } from 'react';

import { useService } from '@xstate/react';
import { Interpreter, PayloadSender, State } from 'xstate';

type AnyInterpreter = Interpreter<any, any, any>;

export const MachineContext = createContext(null as any);

export const useMachineContext = (
  machineContext: typeof MachineContext
): [State<any>, PayloadSender<any>] => {
  if (!machineContext) {
    throw new Error('useMachineContext requires a valid context object');
  }
  const machineService = useContext<AnyInterpreter>(machineContext);

  if (!machineService) {
    throw new Error(
      `useMachineContext should be used with MachineContext.Provider`
    );
  }

  return useService(machineService);
};
